<template>
    <div>
<!--        <van-sticky>-->
<!--&lt;!&ndash;            <van-nav-bar&ndash;&gt;-->
<!--&lt;!&ndash;                    title="公司新闻"&ndash;&gt;-->
<!--&lt;!&ndash;                    left-text=""&ndash;&gt;-->
<!--&lt;!&ndash;                    left-arrow&ndash;&gt;-->
<!--&lt;!&ndash;                    @click-left="back()"&ndash;&gt;-->
<!--&lt;!&ndash;            />&ndash;&gt;-->
<!--            <van-search-->
<!--                    v-model="key"-->
<!--                    show-action-->
<!--                    placeholder="标题/新闻内容"-->
<!--                    @search="onSearch"-->
<!--                    clearable-->
<!--                    left-icon=""-->
<!--            >-->
<!--                <template #action>-->
<!--                    <div @click="onSearch">-->
<!--                        <van-icon name="search" size="1.5rem" style="vertical-align: middle"/>-->
<!--                    </div>-->
<!--                </template>-->
<!--            </van-search>-->
<!--        </van-sticky>-->
<!--        <van-pull-refresh v-model="isLoading" @refresh="onRefresh" style="height: calc(100vh - 54px); overflow: auto;">-->
<!--            <van-list-->
<!--                    v-model="loading"-->
<!--                    :finished="finished"-->
<!--                    finished-text="没有更多了"-->
<!--                    @load="onLoad"-->
<!--            >-->
<!--                <van-cell v-for="item in list" :key="item.newsId"-->
<!--                          @click="showDetail(item.newsId)">-->

<!--                    <div style='display:-webkit-box;'>-->
<!--                        <div style='-webkit-box-flex:1;'>-->
<!--                            {{item.newsTitle}}-->
<!--                        </div>-->

<!--                    </div>-->
<!--                    <van-image style="border: 1px solid #ebedf0" v-if="item.isShowImage" :src="item.newsContent | formatContent"></van-image>-->
<!--                    <p class="newstime">{{item.auditTime}}</p>-->
<!--                </van-cell>-->
<!--            </van-list>-->
<!--        </van-pull-refresh>-->

<!--        <van-popup v-model="showDetailCont" :style="{ height: '100%', width:'100%',overflow: 'hidden'}">-->
<!--&lt;!&ndash;            <van-nav-bar&ndash;&gt;-->
<!--&lt;!&ndash;                    title="新闻内容"&ndash;&gt;-->
<!--&lt;!&ndash;                    fixed&ndash;&gt;-->
<!--&lt;!&ndash;                    left-arrow&ndash;&gt;-->
<!--&lt;!&ndash;                    z-index="9000"&ndash;&gt;-->
<!--&lt;!&ndash;                    @click-left="() => this.showDetailCont = false"&ndash;&gt;-->
<!--&lt;!&ndash;            />&ndash;&gt;-->
<!--           -->
<!--            <van-row style="background-color: #f7f8fa;height: 46px;line-height: 46px">-->

<!--                    <a type="info" native-type="submit" class="button" style="color:#6685a4;font-size: 14px"-->
<!--                                @click="() => this.showDetailCont = false">-->
<!--                        关闭-->
<!--                    </a>-->

<!--            </van-row>-->
<!--        </van-popup>-->
        <div>
            <div class="searchwarp">
                <div class="van-cell-group van-hairline--top-bottom van-panel" style="border-bottom: 0">
                    <div class="van-cell van-panel__header">
                        <div class="van-cell__title">
                            <span style="font-weight: bold">{{detailData.newsTitle}}</span>
                            <div class="van-cell__label">{{detailData.auditTime}}</div>
                        </div>
                    </div>
                    <div class="van-panel__content" style="line-height: 1.8">
                        <div class="content" v-html="detailData.newsContent"></div>
                        <div v-if="showAttach">附件下载:</div>
                        <div v-for="item in detailData.attaches" :key="item.newsAttachId">
                            <a :href="item.attachUrl"
                               style="color: #6685a4;font-size: 14px; padding: 12px 0;display: inline-block">{{item.attachName}}</a>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import {
        Button,
        Calendar,
        Cell,
        Col,
        Divider,
        Field,
        Form,
        Grid,
        GridItem,
        Icon,
        Image as VanImage,
        ImagePreview,
        Lazyload,
        List,
        NavBar,
        Picker,
        Popup,
        PullRefresh,
        Radio,
        RadioGroup,
        Row,
        Search,
        Sticky,
        SwipeCell,
        Toast
    } from 'vant';
    import service from '../../server/index'
    import {resCode} from "../../utils/tools";

    Vue.use(Lazyload, {
        lazyComponent: true,
    });

    export default {
        name: "Fleet",
        components: {
            [NavBar.name]: NavBar,
            [Search.name]: Search,
            [List.name]: List,
            [Col.name]: Col,
            [Row.name]: Row,
            [Cell.name]: Cell,
            [SwipeCell.name]: SwipeCell,
            [Button.name]: Button,
            [Popup.name]: Popup,
            [Icon.name]: Icon,
            [Field.name]: Field,
            [PullRefresh.name]: PullRefresh,
            [Sticky.name]: Sticky,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Calendar.name]: Calendar,
            [Divider.name]: Divider,
            [VanImage.name]: VanImage,
            [ImagePreview.Component.name]: ImagePreview.Component,
            [Grid.name]: Grid,
            [GridItem.name]: GridItem,
            [Form.name]: Form,
            [Picker.name]: Picker
        },
        computed: {},
        data() {
            return {
                list: [],
                detailList: [],
                loading: true,
                finished: false,
                isLoading: false,
                page: 1,
                pageSize: 20,
                showDetailCont: false,
                detailData: {
                    newsContent: undefined,
                    newsTitle: undefined,
                    newsTypeName: undefined,
                    createPerson: undefined,
                    auditTime: undefined,
                    newsId: undefined,
                    attaches: [],
                },
                showAttach: false,
                key: '',
            }
        },
        mounted() {
            // this.onLoad();
            this.showDetail(this.$route.params.newsId)
        },
        filters: {
            formatContent(content) {
                if (content != null) {
                    if (content.indexOf('<img') != -1) {
                        let imgSrc = content.substring(content.indexOf('<img src="'))
                        let http = imgSrc.substring(imgSrc.indexOf('h'))
                        let imageUrl = http.substring(0, http.indexOf('"'))
                        return imageUrl
                    } else {
                        return ''
                    }
                } else {
                    return ''
                }
            }
        },
        methods: {
            isShowImage(content) {
                if (content != null) {
                    if (content.indexOf('<img') != -1) {
                        return true
                    } else {
                        return false
                    }
                }
            },
            onRefresh() {
                this.onLoad();
            },
            showDetail(newsId) {
                this.showDetailCont = true
                this.selNewsByIDG(newsId)
            },
            selNewsByIDG(newsId) {
                let param = {
                    newsId: newsId,
                }
                let url = process.env.VUE_APP_API+process.env.VUE_APP_NAME
                service.selNewsByIDG(url,param).then(res => {
                    if (res.code == resCode.success) {
                        this.detailData = res.data
                        if (res.data.attaches.length > 0) {
                            this.showAttach = true
                        } else {
                            this.showAttach = false
                        }
                    } else {
                        Toast(res.msg)
                    }
                })
            },
            back() {
                this.$router.replace("/Home/Search")
            },
            addPop() {
                this.show = true;
                this.addShowPop = true;
            },
            onSearch() {
                this.list = [];
                this.page = 1;
                this.onLoad();
            },
            onLoad() {

            },
            selNewsG() {
                let param = {
                    page: this.page,
                    count: this.pageSize,
                    ouid: process.env.VUE_APP_OUID,
                    newsTypeId: 1,
                    key: this.key,
                }
                let url = process.env.VUE_APP_API+process.env.VUE_APP_NAME
                service.selNewsG(url,param).then(res => {
                    if (res.code == resCode.success) {
                        if (res.data.length > 0) {
                            for (let i = 0; i < res.data.length; i++) {
                                let isShowImage = this.isShowImage(res.data[i].newsContent)
                                res.data[i].isShowImage = isShowImage
                                this.list.push(res.data[i]);
                            }
                            this.page++
                        } else {
                            this.finished = true;
                        }
                        // 加载状态结束
                        this.loading = false;
                        this.isLoading = false;
                    } else {
                        this.loading = false;
                        this.finished = true;
                        this.isLoading = false;
                        Toast(res.msg)
                    }
                })
            },
        }
    }
</script>

<style scoped>
    .searchwarp {
        margin-top: 0px;
        height: calc(100vh - 46px);
        overflow: auto;
    }

    .van-list .van-cell__value--alone {
        text-align: left;
        font-weight: bold;
        word-break:break-all;
    }
    .van-list .van-cell img{
        width: 80px;margin-left: 10px;height: 80px;
        border-width:1px;
        border-color:#ebedf0;
    }

    /deep/ .van-cell__title {
        text-align: left;
        -webkit-box-flex: unset;
        -webkit-flex: unset;
        flex: unset;
    }

    .van-panel__content {
        padding: 10px 16px;
        text-align: left;
        font-size: 16px;
    }

    .searchwarp .van-hairline--top-bottom::after {
        border-width: 0;
    }
    .newstime{
        margin: 0;
        color: #969799;
        font-weight: normal;
    }

    .content >>> img{
        max-width: 100%;
    }
</style>
